function Divider({ classes = '' }) {
  return <div className={'divider ' + classes} />
}

export default Divider
